
import {rzButton} from 'razlet-ui';
import seo from '~/mixins/seo';

export default {
  name: 'bids-request',
  layout: 'index',
  transition: 'fade',
  components: {
    rzButton,
  },
  mixins: [seo],
  data() {
    return {
      isReturnWindowOpened: false,
      returnWindowType: null,
    };
  },
  methods: {
    findTicket() {
      const event = new CustomEvent('open-find', {});
      window.dispatchEvent(event);
    },
  },
};
